import { NgModule } from '@angular/core';
import { BmsjHipsterSharedModule } from '../shared';
import { RouterModule } from '@angular/router';
import { ONTOLOGY_MANAGER_ROUTES } from './ontology-manager.route';
import { OntologyManagerComponent } from './ontology-manager.component';
import { MethodsPaneComponent } from './tabs/methods/methods-pane.component';
import { VariablesPaneComponent } from './tabs/variables/variables-pane.component';
import { PropertiesPaneComponent } from './tabs/properties/properties-pane.component';
import { ScalesPaneComponent } from './tabs/scales/scales-pane.component';
import { TruncateSpanComponent } from '../shared/util/span-truncate/truncate-span.component';
import { ScaleService } from '../shared/ontology/service/scale.service';
import { MethodService } from '../shared/ontology/service/method.service';
import { PropertyService } from '../shared/ontology/service/property.service';
import { VariableService } from '../shared/ontology/service/variable.service';
import { ScaleDialogComponent, ScalePopupComponent } from './tabs/scales/scale-dialog.component';
import { OntologyContext } from './ontology.context';
import { NumericRangeComponent } from './shared/numeric-range/numeric-range-component';
import { CategoriesComponent } from './shared/categories/categories-component';
import { InputComponent } from './shared/input/input-component';
import { TextareaComponent } from './shared/text-area/text-area-component';
import { SelectComponent } from './shared/select/select-component';
import { MethodDialogComponent } from './tabs/methods/method-dialog.component';
import { PropertyDialogComponent, PropertyPopupComponent } from './tabs/properties/property-dialog.component';
import { MethodPopupComponent } from './tabs/methods/method-dialog.component';
import { VariableDialogComponent, VariablePopupComponent } from './tabs/variables/variable-dialog.component';
import { OntologyService } from '../shared/ontology/service/ontology.service';
import { MultiSelectComponent } from './shared/multi-select/multi-select.omponent';
import { MetadataComponent } from './shared/metadata/metadata.component';
import { FormulaComponent } from './shared/formula/formula.component';
import { FormulaService } from '../shared/ontology/service/formula.service';
import { FormulaDialogComponent } from './shared/formula/dialog/formula-dialog.component';
import { FormulaEditorComponent } from './shared/formula/formula-editor/formula-editor.component';
import { InputVariableComponent } from './shared/formula/input-variable/input-variable.component';
import { HelpLinkComponent } from '../shared/help-link/help-link.component';

@NgModule({
    imports: [
        BmsjHipsterSharedModule,
        RouterModule.forChild(ONTOLOGY_MANAGER_ROUTES),
        TruncateSpanComponent,
        HelpLinkComponent
    ],
    declarations: [
        OntologyManagerComponent,
        VariablesPaneComponent,
        VariableDialogComponent,
        VariablePopupComponent,
        PropertiesPaneComponent,
        PropertyDialogComponent,
        PropertyPopupComponent,
        MethodsPaneComponent,
        MethodDialogComponent,
        MethodPopupComponent,
        ScalesPaneComponent,
        ScaleDialogComponent,
        ScalePopupComponent,
        NumericRangeComponent,
        CategoriesComponent,
        InputComponent,
        TextareaComponent,
        SelectComponent,
        MultiSelectComponent,
        MetadataComponent,
        FormulaComponent,
        FormulaEditorComponent,
        FormulaDialogComponent,
        InputVariableComponent
    ],
    providers: [
        VariableService,
        ScaleService,
        MethodService,
        PropertyService,
        OntologyService,
        FormulaService,
        OntologyContext
    ]
})
export class OntologyManagerModule {
}
